export default "__VITE_ASSET__6c888358__"